import { takeEvery } from 'redux-saga/effects';
import { GET_INIT_ADC_DATA } from './adcpincode.action';
import { getInitAdcPincodeDataSaga } from './adcpincode.saga';

export const adcPincodeSaga = [
  takeEvery(GET_INIT_ADC_DATA, getInitAdcPincodeDataSaga),
];
